/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/Pepe.glb -o src/models/Pepe.jsx --draco --transform --simplify --resolution=512 
Files: public/Pepe.glb [6.6MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/Pepe-transformed.glb [517.43KB] (92%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../assets/models/Pepe-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes['tripo_node_ca604110-0fa2-4cec-999e-75632de54353'].geometry} material={materials['tripo_mat_ca604110-0fa2-4cec-999e-75632de54353']} />
    </group>
  )
}

useGLTF.preload(modelUrl)
